import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/image';

const ImageCropper = ({ imageSrc, onCropComplete, onCancel, aspect = 1, initialZoom = 1 }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(initialZoom);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');

  const onCropChange = (newCrop) => setCrop(newCrop);
  const onZoomChange = (newZoom) => setZoom(newZoom);

  const onCropCompleteInternal = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropAndSave = async () => {
    if (!croppedAreaPixels) return;
    setProcessing(true);
    setError('');
    try {
      // Pass croppedAreaPixels directly
      const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels, zoom, aspect);
      onCropComplete(croppedBlob);
    } catch (err) {
      setError('Failed to crop image.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="bg-green-950 border border-green-500 p-6 rounded-xl shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto relative font-mono flex flex-col items-center">
        <h2 className="text-xl text-green-400 mb-4 text-center glitch-text">Crop Your Image</h2>
        <div className="relative w-full h-72 bg-black rounded-lg overflow-hidden mb-4">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropCompleteInternal}
            cropShape="rect"
            showGrid={true}
          />
        </div>
        <div className="w-full flex flex-col gap-2 mb-4">
          <label className="text-green-300 text-xs">Zoom</label>
          <input
            type="range"
            min={1}
            max={3}
            step={0.01}
            value={zoom}
            onChange={e => setZoom(Number(e.target.value))}
            className="w-full"
          />
        </div>
        {error && <div className="text-red-400 text-xs mb-2">{error}</div>}
        <div className="flex gap-4 w-full">
          <button
            className="btn-primary flex-1"
            onClick={handleCropAndSave}
            disabled={processing}
          >
            {processing ? 'Processing...' : 'Crop & Save'}
          </button>
          <button
            className="btn-secondary flex-1"
            onClick={onCancel}
            disabled={processing}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper; 